/**
 * RISK-ADD.MODAL
 * Add new risks
 */
import Modal from "@/components/modal"
import { t } from "i18next"
import { useNavigate } from "react-router-dom"
import UnitSelect from "@/features/risks/entities/unit/ui/UnitSelect"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import unitStore from "@/features/risks/entities/unit/model/unit.store"

interface Props {
  onClose: () => void
}

export default function RiskAddModal({ onClose }: Props) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const active = useAppSelector(unitStore.selectors.active)

  function handleNext() {
    navigate("/risks/risks-add", { state: { backTo: "/risks" } })
  }

  return (
    <Modal
      className="rel"
      isCloseButtonVisible
      onClose={() => {
        dispatch(unitStore.actions.setActive(null))
        onClose()
      }}
      disableOverflow
      onNext={handleNext}
      nextDisabled={!active?.name}
      nextDisabledTooltip={!active?.name ? "Sélectionnez une unité de travail" : undefined}>
      <div className="text-center">
        <h1>{t("Sélectionnez une unité de travail")}</h1>
        <p>{t("Dans quelle unité de travail souhaitez-vous ajouter un risque ?")}</p>
      </div>
      <div className="mt-3 w-full">
        <UnitSelect selectMultiple />
      </div>
    </Modal>
  )
}
